import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/fridge-not-cooling-repair", label: "Not Cooling Repair" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
  { to: "/single-door-fridge-service-bangalore", label: "Single Door Service" },
  { to: "/mini-fridge-service-bangalore", label: "Mini Fridge Service" },
];

const FridgeNoiseProblem = () => {
  return (
    <FridgePageTemplate
      title="Fridge Noise Problem Repair in Bangalore"
      description="Professional fridge noise problem repair in Bangalore for loud compressors, fan noise, and vibration issues."
      keywords="fridge noise problem repair bangalore, refrigerator noise issue, noisy fridge repair"
      path="/fridge-noise-problem"
      bannerTitle="Fridge Noise Problem"
      intro={
        <>
          Loud or strange noises from your <span style={{ fontWeight: "bold" }}>refrigerator</span> can indicate compressor, fan, or internal component issues. Our Bangalore team handles fridge noise diagnostics and repair.
        </>
      }
      highlights={[
        "Compressor and fan noise diagnosis",
        "Vibration and mounting support",
        "Airflow and condenser cleaning",
        "Fast home repair for noisy fridges",
      ]}
      issues={[
        "Humming or buzzing sounds",
        "Loud fan noise",
        "Rattling or vibration",
        "Clicking from compressor",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeNoiseProblem;

